import { useMutation } from 'react-query';

import { QueryParams, extractPivotTableToCsv as mutationFn } from 'api/endPoints/extractPivotTableToCsv';

export const useMutationExtractPivotTableToCsv = () => {
    return useMutation({
        mutationFn: (params: QueryParams) => mutationFn(params),
    });
};
